module.exports = __webpack_public_path__ + "static/img/proNew.f691a71e.jpg";